function createElement(assetsToBeLoaded) {
  return assetsToBeLoaded.map(({ type, src, defer }) => {
    let element = {};
    return new Promise((resolve) => {
      switch (type) {
        case 'script':
          element = document.createElement('script');
          element.src = src;
          element.type = 'text/javascript';
          element.async = false;
          element.defer = defer;
          element.charset = 'UTF-8';
          element.onload = _elem => resolve(_elem);
          document.body.appendChild(element);
          break;
        case 'link':
          element = document.createElement('link');
          element.href = src;
          element.rel = 'stylesheet';
          element.async = false;
          element.defer = defer;
          element.onload = _elem => resolve(_elem);
          document.head.appendChild(element);
          break;
        default: break;
      }
    });
  });
}

export default async function injectRegistrationScripts() {
  const assetsToBeLoaded = [
    { type: 'link', src: '/assets/dest/css/intlInput.css', defer: false },
    {
      type: 'script',
      src: 'https://storage.googleapis.com/clientaccess/registration/InputValidator.js',
      defer: false,
    },
    {
      type: 'script',
      src: 'https://storage.googleapis.com/branding-resources/tz-moment.js',
      defer: false,
    },
    {
      type: 'script',
      src: 'https://storage.googleapis.com/clientaccess/registration/IntlTelInput/intlTelInputUtils.js',
      defer: false,
    },
  ];

  if (
    (document.getElementById('registration')
      || document.getElementById('demo-signup'))
    && !document.querySelector(
      'script[src="https://storage.googleapis.com/clientaccess/registration/InputValidator.js"]',
    )
  ) {
    if (document.getElementById('registration')) {
      assetsToBeLoaded.push({ type: 'script', src: '/assets/dest/js/registrationHelper.js?v=4', defer: false });
    }

    if (document.getElementById('demo-signup') && !document.querySelector('script[src="/assets/dest/js/demo-signup.js?v=3"]')) {
      assetsToBeLoaded.push({ type: 'script', src: '/assets/dest/js/demo-signup.js?v=3', defer: true });
    }

    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(
      () => true,
    );
    return isAppened;
  }
  return true;
}

export async function injectDefaultScripts() {
  let assetsToBeLoaded = [];

  if (document.getElementById('trees-animation') && !document.querySelector('script[src="/assets/dest/js/trees.js?v=3"]')) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/trees.js?v=3', defer: true }]);
  }

  if (document.getElementById('app-features-section') && !document.querySelector('script[src="/assets/dest/js/global-slider-config-v3.js?v=2"]')) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/global-slider-config-v3.js?v=2', defer: true }]);
  }

  if (document.getElementById('trustbox-widget') && !document.querySelector('script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]')) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', defer: true }]);
  }

  if (document.getElementById('agent-call-rec') && !document.querySelector('script[src="/assets/dest/js/audioPlayer.js?v=2"]')) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/audioPlayer.js?v=2', defer: true }]);
  }

  if (document.getElementById('Setmore_button_iframe') && !document.querySelector('script[src="https://assets.setmore.com/integration/static/setmoreIframeLive.js"]')) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: 'https://assets.setmore.com/integration/static/setmoreIframeLive.js', defer: true }]);
  }

  if (document.querySelector('.js-book') && !document.querySelector('script[src="/assets/dest/js/books.js?v=1"]')) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/books.js?v=1', defer: true }]);
  }

  if (document.getElementById('videoPlayer') && !document.querySelector('script[src="/assets/dest/js/video-modal.js?v=16"]')) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/assets/dest/js/video-modal.js?v=16', defer: true }]);
  }

  if (assetsToBeLoaded.length > 0) {
    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppened;
  }
  return true;
}
